import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from '@/components/ui/resizable';
import useDispatchState from './dispatch/useDispatchState';
import DriverSidebar from './dispatch/DriverSidebar';
import DispatchToolbar from './dispatch/DispatchToolbar';
import PendingLoadsGrid from './dispatch/PendingLoadsGrid';
import ActiveLoadsGrid from './dispatch/ActiveLoadsGrid';
import DispatchSettingsDialog from './dispatch/DispatchSettingsDialog';

export default function AdminDispatch() {
  const state = useDispatchState();

  if (state.loading) {
    return (
      <div className="flex justify-center items-center h-[calc(100vh-64px)]">
        <div className="w-8 h-8 border-2 border-brand-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-64px)] flex flex-col" data-testid="admin-dispatch">
      {/* Toolbar */}
      <DispatchToolbar
        selectedDriverId={state.selectedDriverId}
        selectedLoadIds={state.selectedLoadIds}
        onSettings={() => state.setShowSettings(true)}
        onRefresh={state.fetchData}
        onAssign={state.assignLoads}
        onDispatch={state.dispatchLoads}
        onCancel={state.cancelLoads}
        onAutoScore={state.handleScore}
      />

      {/* Main content: sidebar + grids */}
      <div className="flex-1 overflow-hidden">
        <ResizablePanelGroup direction="horizontal">
          {/* Driver Sidebar */}
          <ResizablePanel defaultSize={20} minSize={15} maxSize={30}>
            <DriverSidebar
              filteredDrivers={state.filteredDrivers}
              driverLoadCounts={state.driverLoadCounts}
              selectedDriverId={state.selectedDriverId}
              setSelectedDriverId={state.setSelectedDriverId}
              selectedDriver={state.selectedDriver}
              driverSearch={state.driverSearch}
              setDriverSearch={state.setDriverSearch}
              driverFilter={state.driverFilter}
              setDriverFilter={state.setDriverFilter}
              hasLoadsOnly={state.hasLoadsOnly}
              setHasLoadsOnly={state.setHasLoadsOnly}
            />
          </ResizablePanel>

          <ResizableHandle className="bg-muted hover:bg-brand-accent/50 transition-colors" />

          {/* Two grids stacked vertically */}
          <ResizablePanel defaultSize={80}>
            <ResizablePanelGroup direction="vertical">
              {/* Top Grid: Pending Loads */}
              <ResizablePanel defaultSize={50} minSize={25}>
                <PendingLoadsGrid
                  pendingLoads={state.pendingLoads}
                  pendingTab={state.pendingTab}
                  setPendingTab={state.setPendingTab}
                  selectedLoadIds={state.selectedLoadIds}
                  toggleLoadSelection={state.toggleLoadSelection}
                  selectAllLoads={state.selectAllLoads}
                  pendingSearch={state.pendingSearch}
                  setPendingSearch={state.setPendingSearch}
                  onScore={state.handleScore}
                  onAutoDispatch={state.handleAutoDispatch}
                />
              </ResizablePanel>

              <ResizableHandle className="bg-muted hover:bg-brand-accent/50 transition-colors" />

              {/* Bottom Grid: Active/Delivered Loads */}
              <ResizablePanel defaultSize={50} minSize={25}>
                <ActiveLoadsGrid
                  activeLoads={state.activeLoads}
                  activeTab={state.activeTab}
                  setActiveTab={state.setActiveTab}
                  selectedLoadIds={state.selectedLoadIds}
                  toggleLoadSelection={state.toggleLoadSelection}
                  selectAllLoads={state.selectAllLoads}
                  activeSearch={state.activeSearch}
                  setActiveSearch={state.setActiveSearch}
                  onRefresh={state.fetchData}
                  onUndeliver={state.undeliverLoads}
                  drivers={state.drivers}
                />
              </ResizablePanel>
            </ResizablePanelGroup>
          </ResizablePanel>
        </ResizablePanelGroup>
      </div>

      {/* Settings Dialog */}
      <DispatchSettingsDialog
        open={state.showSettings}
        onOpenChange={state.setShowSettings}
        rules={state.rules}
        setRules={state.setRules}
        onSave={state.handleSaveRules}
      />
    </div>
  );
}
